import ReactGA from 'react-ga4'

export const initGA = () => {
    if (process.env.NODE_ENV === 'production') {
        ReactGA.initialize('G-M3MHQ8QXXY')
    }
}
export const logPageView = () => {
    if (process.env.NODE_ENV === 'production') {
        ReactGA.set({ page: window.location.pathname });
        ReactGA.send({ hitType: "pageview", page: window.location.pathname });
    }
}
export const logEvent = (category = '', action = '') => {
    if (process.env.NODE_ENV === 'production') {
        if (category && action) {
            ReactGA.event({ category, action });
        }
    }
}
export const logException = (description = '', fatal = false) => {
    if (process.env.NODE_ENV === 'production') {
        if (description) {
            ReactGA.exception({ description, fatal });
        }
    }
}